import { createReducer, on } from '@ngrx/store';

import { Protocol } from '../models/protocol.model';
import { appendProtocols, removeProtocol, setProtocols, setProtocolsLoading, updateProtocol } from './protocols.actions';

export interface ProtocolsState {
  items: Protocol[];
  continuationToken: string | null;
  loading: boolean;
}

const initialState: ProtocolsState = {
  items: [],
  continuationToken: null,
  loading: false,
};

export const protocolsReducer = createReducer(
  initialState,
  on(setProtocols, (state, { protocols, continuationToken }) => ({
    ...state,
    items: protocols,
    continuationToken,
  })),
  on(appendProtocols, (state, { protocols, continuationToken }) => ({
    ...state,
    items: [...state.items, ...protocols],
    continuationToken,
  })),
  on(updateProtocol, (state, { protocol }) => ({
    ...state,
    items: state.items.map(item => (item.id === protocol.id ? protocol : item)),
  })),
  on(removeProtocol, (state, { id }) => ({
    ...state,
    items: state.items.filter(item => item.id !== id),
  })),
  on(setProtocolsLoading, (state, { loading }) => ({ ...state, loading }))
);
